// src/ViewSwitcher.js
import React from "react";
import "./ViewSwitcher.css";

const ViewSwitcher = ({ currentView, onViewChange }) => {
  return (
    <div className="view-switcher-container">
      <div className="view-switcher">
        <span
          className={`view-option ${
            currentView === "detailed" ? "active" : "inactive"
          }`}
          onClick={() => currentView !== "detailed" && onViewChange("detailed")}
        >
          Detailed View
        </span>
        <span className="view-separator">|</span>
        <span
          className={`view-option ${
            currentView === "simplified" ? "active" : "inactive"
          }`}
          onClick={() =>
            currentView !== "simplified" && onViewChange("simplified")
          }
        >
          Demo View
        </span>
      </div>
    </div>
  );
};

export default ViewSwitcher;
